/* eslint-disable no-unused-vars */
export enum StructureTypeCode {
  BNDEFP = "BND EFP",
  BNDFLY = "BND FLY",
  BNDPACK = "BND PACK",
  BNDSWI = "BND SWI",
  BNDCON = "BND CON",
  BNDO = "BNDO",
  CORP = "CORP",
  FUTPACK = "FUT PACK",
  FUTIRF = "FUT IRF",
  GOVT = "GOVT",
  IBS = "IBS",
  IRS = "IRS",
  NOVPACK = "NOV PACK",
  NPVPACK = "NPV PACK",
  OIS = "OIS",
  OPTPACK = "OPT PACK",
  PACK = "PACK",
  SEMI = "SEMI",
  SWO = "SWO",
  SWPCON = "SWP CON",
  SWPEFP = "SWP EFP",
  SWPFLY = "SWP FLY",
  SWPSPD = "SWP SPD",
  SWPTFR = "SWP TFR",
  ZCS = "ZCS",
  ElevenAM = "11AM",
  ABS = "ABS",
  BILL = "BILL",
  CALL = "CALL",
  CD = "CD",
  CDO = "CDO",
  CDS = "CDS",
  CDSO = "CDSO",
  CDX = "CDX",
  CFL = "CFL",
  CMO = "CMO",
  COLL = "COLL",
  CP = "CP",
  EXO = "EXO",
  FRA = "FRA",
  FRD = "FRD",
  FUTBILL = "FUT BILL",
  FUTBND = "FUT BND",
  FXF = "FXF",
  FXO = "FXO",
  FXS = "FXS",
  LTD = "LTD",
  MBS = "MBS",
  NCD = "NCD",
  OBS = "OBS",
  OPTFUTBILL = "OPT FUT BILL",
  OPTFUTBND = "OPT FUT BND",
  OPTFUTIRF = "OPT FUT IRF",
  PNOTE = "PNOTE",
  REPO = "REPO",
  SELLBUY = "SELLBUY",
  SUPRA = "SUPRA",
  SYN = "SYN",
  TD = "TD",
  VAR = "VAR",
  VOL = "VOL",
  XBS = "XBS",
  XCS = "XCS",
  STRADDLE = "STRADDLE",
  STRANGLE = "STRANGLE",
  REPOPACK = "REPO PACK",
  SWPPACK = "SWP PACK",
  SYNREPO = "SYN REPO",
  SYNREVREP = "SYN REV REPO",
}
